import React from 'react'
import { Typography, Divider } from 'antd'
import { useTheme } from '../../contexts/ThemeContext'

const { Title, Paragraph, Text } = Typography

export default function TermsOfService() {
  const { isDark } = useTheme()
  const bgColor = isDark ? '#141414' : '#ffffff'
  const textColor = isDark ? '#e8e8e8' : '#333'
  const mutedColor = isDark ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.45)'

  return (
    <div style={{
      maxWidth: 800,
      margin: '0 auto',
      padding: '40px 24px',
      backgroundColor: bgColor,
      minHeight: '100vh',
      color: textColor,
    }}>
      <Title level={2} style={{ color: textColor, textAlign: 'center' }}>
        Termos de Uso
      </Title>
      <Text style={{ display: 'block', textAlign: 'center', color: mutedColor, marginBottom: 32 }}>
        Última atualização: Maio de 2026
      </Text>

      <Divider style={{ borderColor: isDark ? '#333' : '#e8e8e8' }} />

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>1. Aceitação dos Termos</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Ao acessar ou utilizar a plataforma EtiquetandoAPP, você declara que atua em nome próprio
          ou em nome da empresa contratante autorizada a utilizar a solução e concorda com estes Termos de Uso.
          Se não concordar com qualquer disposição, não utilize a plataforma.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>2. Descrição do Serviço</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          O EtiquetandoAPP é uma plataforma B2B voltada a operações logísticas e industriais,
          incluindo emissão de etiquetas, Expedição, integrações operacionais, rastreabilidade e
          rotinas de apoio ao fluxo da empresa contratante.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>3. Acesso e Credenciais</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          A plataforma não opera com autocadastro público. O acesso é liberado exclusivamente para usuários
          vinculados a clientes contratantes, com credenciais fornecidas, sincronizadas ou autorizadas pela
          base de dados e pelos processos internos da própria empresa contratante. O usuário deve manter a
          confidencialidade de seu login e senha e comunicar imediatamente qualquer uso indevido.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>4. Uso Permitido</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          O uso da plataforma deve se limitar a finalidades corporativas legítimas da operação contratada.
          É proibido utilizar a plataforma para fraude, compartilhamento indevido de credenciais, tentativa
          de acesso não autorizado, engenharia reversa ou qualquer ato que comprometa a segurança do ambiente.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>5. Propriedade Intelectual</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Todo o conteúdo, software, marcas e tecnologias da plataforma são de propriedade exclusiva
          do EtiquetandoAPP ou de seus licenciadores. Nenhuma parte da plataforma pode ser copiada,
          modificada ou distribuída sem autorização prévia por escrito.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>6. Limitação de Responsabilidade</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          O EtiquetandoAPP não se responsabiliza por danos indiretos, incidentais ou consequenciais
          decorrentes de uso indevido da plataforma, falhas em credenciais mantidas pelo contratante,
          indisponibilidades causadas por terceiros ou dados cadastrados incorretamente pela empresa contratante
          ou seus usuários, sem prejuízo das obrigações legais e contratuais aplicáveis.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>7. Privacidade e Dados</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          O tratamento de dados pessoais segue a Política de Privacidade da plataforma, disponível em
          <a href="/#/privacidade" style={{ color: '#1890ff', marginLeft: 4 }}>/#/privacidade</a>.
          Em ambiente B2B, a empresa contratante pode atuar como controladora dos dados operacionais inseridos
          por seus usuários, enquanto a Etiquetando atua no tratamento necessário para prestar o serviço.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>8. Disposições Gerais</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Estes Termos são regidos pela legislação brasileira. Eventuais controvérsias serão tratadas
          conforme o contrato firmado com a empresa contratante e, na ausência de disposição específica,
          no foro da comarca de Blumenau - SC. Podemos atualizar estes Termos para refletir evoluções
          legais, contratuais ou operacionais da plataforma.
        </Paragraph>
      </section>

      <Divider style={{ borderColor: isDark ? '#333' : '#e8e8e8' }} />

      <Text style={{ display: 'block', textAlign: 'center', color: mutedColor, fontSize: 12 }}>
        EtiquetandoAPP - Todos os direitos reservados
      </Text>
    </div>
  )
}
